import { useAppSelector } from "../../../../../stateManagement/hooks/redux";
import { trafficIntensityTooltipRows } from "../trafficIntensityTooltipConfig";

function hasTooltipValue(value: number | null | undefined): boolean {
    return value != null && value !== 0;
}

export default function TrafficIntensityContent() {
    const data = useAppSelector(state => state.mapTooltip.data);
    const { TotalIntensity } = data ?? {};
    const rowsWithData = trafficIntensityTooltipRows.filter(({ field }) => hasTooltipValue(data?.[field]));

    return (
        <>
            {hasTooltipValue(TotalIntensity) && (
                <div className="tooltip-info-row">Общая интенсивность: {TotalIntensity}</div>
            )}
            <div className="tooltip-info-grid">
                {rowsWithData.map(({ field, label }) => (
                    <div className="tooltip-grid-row" key={field}>
                        <span className="tooltip-grid-label">{label}</span>
                        <span className="tooltip-grid-value">{data?.[field]}</span>
                    </div>
                ))}
            </div>
        </>
    );
}
